import React, { useCallback, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';

import { mutationEditorReset } from 'gql/mutations/editor';
import { useMutationLMSGradeSynchronize } from 'gql/mutations/lms';
import { useQueryCourseTestSessions } from 'gql/queries/course';
import { trackEvent, reportError } from 'lib/tracking';
import { notify } from 'uikit/Notifications';

import TestResults from './TestResults';

const TestResultsContainer = (props) => {
  const { t } = useTranslation();
  const { courseId } = useParams();
  const { isLoading, data } = useQueryCourseTestSessions({
    variables: {
      courseId,
    },
  });
  const isEmpty = isLoading ? false : data.course.testSessions.length === 0;
  useEffect(() => {
    mutationEditorReset();
    return () => {
      mutationEditorReset();
    };
  }, []);
  const mutationLMSGradeSynchronize = useMutationLMSGradeSynchronize();
  const handleGradeSynchronize = useCallback(async () => {
    try {
      await mutationLMSGradeSynchronize({ courseId });
      trackEvent('LMS', 'grade synchronize');
      notify('success', t('Course/Teacher/TestResults/grade-synchronized'));
    } catch (err) {
      reportError('LMS', 'grade synchronize', err);
    }
  }, [courseId, mutationLMSGradeSynchronize, t]);
  return (
    <TestResults
      course={data?.course}
      handleGradeSynchronize={handleGradeSynchronize}
      isEmpty={isEmpty}
      isLoading={isLoading}
      t={t}
      {...props}
    />
  );
};

export default TestResultsContainer;
